"use client";

import { createContext, useContext } from "react";
import { AutumnClient } from "./client/ReactAutumnClient";
const AutumnContext = createContext({
  // customer: undefined,
  // refetchCustomer: () => Promise.resolve(),
  refetchCustomer: null,
  setRefetchCustomer: () => {
  },
  entity: null,
  setEntity: () => {
  },
  refetchPricingTable: () => Promise.resolve(),
  setRefetchPricingTable: () => {
  },
  client: new AutumnClient({
    backendUrl: "http://localhost:8000"
  }),
  paywallDialog: {
    props: null,
    setProps: () => {
    },
    open: false,
    setOpen: () => {
    },
    setComponent: () => {
    }
  },
  prodChangeDialog: {
    props: null,
    setProps: () => {
    },
    open: false,
    setOpen: () => {
    },
    setComponent: () => {
    }
  }
});
const useAutumnContext = () => {
  const context = useContext(AutumnContext);
  if (context === void 0) {
    throw new Error(
      "useAutumnContext must be used within a AutumnContextProvider"
    );
  }
  return context;
};
export {
  AutumnContext,
  useAutumnContext
};
